<template>
  <div class="print-root">
    <!-- Hazır kağıt hizalama çubuğu (baskıya gitmez) -->
    <div class="calib no-print">
      <span class="calib-title">Hazır Kağıt Hizalama</span>
      <label class="calib-field">X (mm)
        <input type="number" step="0.5" v-model.number="offsetX" />
      </label>
      <label class="calib-field">Y (mm)
        <input type="number" step="0.5" v-model.number="offsetY" />
      </label>
      <button class="calib-btn" @click="doPrint">
        Yazdır
      </button>
      <button class="calib-btn ghost" @click="resetOffset">Sıfırla</button>
      <span class="calib-hint">
        Değerler aşağı kalsın → Y'yi artır · sağa kalsın → X'i artır. Ön yüz basılmaz, yalnızca değerler basılır.
      </span>
    </div>

    <div class="print-page">
      <cert-classic
        v-if="certData"
        :item="certData"
        :offset-x="offsetX"
        :offset-y="offsetY"
      />
      <div v-else class="no-data">Sertifika verisi bulunamadı.</div>
    </div>
  </div>
</template>

<script>
import CertClassic from "@/components/certificates/CertClassic.vue";

const REG_KEY = "jewelryCertRegOffset";

export default {
  components: { CertClassic },
  data: () => ({
    certData: null,
    offsetX: 0,
    offsetY: 0,
  }),
  mounted() {
    this.$store.commit("SET_LAYOUT", "empty-layout");
    const params = new URLSearchParams(window.location.search);

    // Hizalama: query > kayıtlı (localStorage) > 0
    let ox = 0;
    let oy = 0;
    try {
      const saved = JSON.parse(localStorage.getItem(REG_KEY) || "{}");
      ox = Number(saved.x) || 0;
      oy = Number(saved.y) || 0;
    } catch (e) {
      /* yok say */
    }
    if (params.get("offsetX") != null) ox = Number(params.get("offsetX")) || 0;
    if (params.get("offsetY") != null) oy = Number(params.get("offsetY")) || 0;
    this.offsetX = ox;
    this.offsetY = oy;

    try {
      const raw = localStorage.getItem("jewelryCertificateData");
      if (raw) this.certData = JSON.parse(raw);
    } catch (e) {
      console.error("Sertifika verisi okunamadı:", e);
    }

    // Hazır kağıt: otomatik yazdırma YOK. Önce hizalanır, sonra "Yazdır" ile
    // basılır (basılı stok israf olmasın).
  },
  methods: {
    persistOffset() {
      try {
        localStorage.setItem(
          REG_KEY,
          JSON.stringify({ x: this.offsetX, y: this.offsetY })
        );
      } catch (e) {
        /* yok say */
      }
    },
    doPrint() {
      this.persistOffset();
      this.$nextTick(() => window.print());
    },
    resetOffset() {
      this.offsetX = 0;
      this.offsetY = 0;
      this.persistOffset();
    },
  },
};
</script>

<style scoped>
.print-page {
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #f5f5f5;
  padding: 20px;
}

.no-data {
  padding: 40px;
  font-size: 18px;
  color: #666;
}

/* Hizalama çubuğu (ekran) */
.calib {
  position: sticky;
  top: 0;
  z-index: 10;
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 12px;
  padding: 10px 16px;
  background: #263238;
  color: #fff;
  font-family: Arial, Helvetica, sans-serif;
  font-size: 13px;
}
.calib-title {
  font-weight: 700;
  letter-spacing: 0.5px;
}
.calib-field {
  display: inline-flex;
  align-items: center;
  gap: 6px;
}
.calib-field input {
  width: 70px;
  padding: 4px 6px;
  border: none;
  border-radius: 4px;
  font-size: 13px;
}
.calib-btn {
  background: #26a69a;
  color: #fff;
  border: none;
  padding: 6px 16px;
  border-radius: 4px;
  cursor: pointer;
  font-size: 13px;
  font-weight: 700;
}
.calib-btn.ghost {
  background: transparent;
  border: 1px solid #607d8b;
}
.calib-hint {
  color: #b0bec5;
  font-size: 12px;
}
</style>

<style>
@page {
  size: 5in 3.5in;
  margin: 0;
}
@media print {
  .no-print {
    display: none !important;
  }
  html, body {
    margin: 0 !important;
    padding: 0 !important;
    width: 5in;
    height: auto;
    background: #fff !important;
  }
  body > * {
    margin: 0 !important;
    padding: 0 !important;
  }
  .print-page {
    background: #fff !important;
    padding: 0 !important;
    margin: 0 !important;
    min-height: 0 !important;
    display: block !important;
  }
  .face {
    margin: 0 !important;
    box-shadow: none !important;
  }
}
</style>
